export var PopupType;
(function (PopupType) {
    PopupType["SIGN_TRANSACTION_REVIEW"] = "SIGN_TRANSACTION_REVIEW";
    PopupType["SIGN_MESSAGE_REVIEW"] = "SIGN_MESSAGE_REVIEW";
    PopupType["LOGIN_PASSKEY"] = "LOGIN_PASSKEY";
    PopupType["CREATE_PASSKEY"] = "CREATE_PASSKEY";
    PopupType["OAUTH"] = "OAUTH";
    PopupType["ON_RAMP_TRANSACTION"] = "ON_RAMP_TRANSACTION";
})(PopupType || (PopupType = {}));
